document.querySelectorAll('.js-scroll-to').forEach(button => {
    button.addEventListener('click', event => {
        event.preventDefault();
        const href = button.getAttribute('href') ?? '';
        const anchorContent = document.querySelector(href);
        const anchorContentOffset = (anchorContent?.getBoundingClientRect().top ?? 0) + window.scrollY;

        window.scrollTo({
            top: anchorContentOffset,
            behavior: 'smooth'
        });
    });
});
